import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ArrowLeft, FileText } from 'react-feather';
import logo from '../../../assets/logo.png';

const ScreenContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${p => p.theme.colors?.background?.default || '#f9fafb'};
  font-family: 'Inter', sans-serif;
`;

const Header = styled.header`
  display: flex;
  align-items: center;
  padding: 20px;
  background-color: ${p => p.theme.colors?.background?.paper || '#ffffff'};
  border-bottom: 1px solid ${p => p.theme.colors?.border?.main || '#e5e7eb'};
`;

const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${p => p.theme.colors?.text?.primary || '#111827'};
  padding: 8px;
  margin-right: 16px;
  border-radius: 8px;
  &:hover {
    background-color: ${p => p.theme.colors?.action?.hover || '#f3f4f6'};
  }
`;

const Logo = styled.img`
  height: 24px;
`;

const Content = styled.div`
  flex: 1;
  padding: 40px 20px;
  max-width: 600px;
  margin: 0 auto;
  width: 100%;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: ${p => p.theme.colors?.text?.primary || '#111827'};
  margin-bottom: 32px;
`;

const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const LinkCard = styled.a`
  display: flex;
  align-items: center;
  padding: 20px;
  background-color: ${p => p.theme.colors?.background?.paper || '#ffffff'};
  border: 1px solid ${p => p.theme.colors?.border?.main || '#e5e7eb'};
  border-radius: 12px;
  text-decoration: none;
  color: ${p => p.theme.colors?.text?.primary || '#111827'};
  transition: all 0.2s ease;

  &:hover {
    border-color: ${p => p.theme.colors?.primary?.main || '#3b82f6'};
    transform: translateY(-2px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: ${p => p.theme.colors?.action?.selected || '#eff6ff'};
  color: ${p => p.theme.colors?.primary?.main || '#3b82f6'};
  margin-right: 16px;
`;

const LinkText = styled.span`
  font-size: 16px;
  font-weight: 500;
`;

const ConsentsScreen = () => {
  const navigate = useNavigate();

  return (
    <ScreenContainer>
      <Header>
        <BackButton onClick={() => navigate(-1)}>
          <ArrowLeft size={20} />
        </BackButton>
        <Logo src={logo} alt="NYBANQ Logo" />
      </Header>
      
      <Content>
        <Title>NYBANQ Customer Consents, Disclosures, and Acknowledgments</Title>
        
        <LinksContainer>
          <LinkCard href="/e-sign" onClick={(e) => { e.preventDefault(); navigate('/e-sign'); }}>
            <IconWrapper><FileText size={20} /></IconWrapper>
            <LinkText>E-Sign Disclosure and Consent Notice</LinkText>
          </LinkCard>

          <LinkCard href="/cip-notice" onClick={(e) => { e.preventDefault(); navigate('/cip-notice'); }}>
            <IconWrapper><FileText size={20} /></IconWrapper>
            <LinkText>CIP Notice Acknowledgement</LinkText>
          </LinkCard>

          <LinkCard href="https://nybanq.com/privacy" target="_blank" rel="noopener noreferrer">
            <IconWrapper><FileText size={20} /></IconWrapper>
            <LinkText>Privacy Policy</LinkText>
          </LinkCard>

          <LinkCard href="https://nybanq.com/terms" target="_blank" rel="noopener noreferrer">
            <IconWrapper><FileText size={20} /></IconWrapper>
            <LinkText>Platform Agreement and Terms of Service</LinkText>
          </LinkCard>
        </LinksContainer>
      </Content>
    </ScreenContainer>
  );
};

export default ConsentsScreen;
